import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { SearchResponse, SearchQueryParams } from '@features/associations/models/search-response';

// Endpoint root
const APIURL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private http = inject(HttpClient);

  // [GET] https://apiv3-staging.a-book.dk/1/search?start=2024-04-03&activityId=77&locationId=1

  search(params: SearchQueryParams): Observable<SearchResponse[]> {
    const { locationId, activityId, resourceId, start, end } = params;
    let httpParams = new HttpParams();
    if (activityId != null) httpParams = httpParams.set('activityId', String(activityId));
    if (locationId != null) httpParams = httpParams.set('locationId', String(locationId));
    if (resourceId != null) httpParams = httpParams.set('resourceId', String(resourceId));
    if (start != null) httpParams = httpParams.set('start', start);
    if (end != null) httpParams = httpParams.set('end', end);
    return this.http
      .get<SearchResponse[]>(`${APIURL}/public/search/`, { params: httpParams })
      .pipe(map((data) => data));
  }
}
